<template>
  <div>
    <div class="row">
      <div class="container">
        <div class="col-md-6">
          <div class="h3 bold">{{ $t('tradeIn.header') }}</div>
          <div class="h4 seasidetms_heading">
            {{ $t('tradeIn.first') }}
          </div>
          <div class="calculator">
            <div class="h3 bold">{{ $t('tradeIn.calcHeader') }}</div>
            <div>
              <div class="select-wrapper">
                <span class="bold">{{ $t('model') }}:</span>
                <select
                  ref="deviceSelect"
                  @change="onDeviceSelect"
                  v-model="model"
                >
                  <option selected disabled value="null">
                    {{ $t('chooseModel') }}
                  </option>
                  <option
                    v-for="(device, i) in models"
                    :value="device.name"
                    :key="`device${i}`"
                  >
                    {{ device.name }}
                  </option>
                </select>
                <i class="fa fa-arrow-down"></i>
              </div>
              <div class="select-wrapper" style="margin-top: 10px">
                <span class="bold" style="margin-right: 10px"
                  >{{ $t('memory') }}:</span
                >
                <select
                  ref="memorySelect"
                  @change="onMemorySelect"
                  v-model="memory"
                  :disabled="!model"
                >
                  <option disabled selected value="null">
                    {{ $t('chooseMemory') }}
                  </option>
                  <option v-for="v in modelVariants" :value="v" :key="v">
                    {{ v }}
                  </option>
                </select>
                <i class="fa fa-arrow-down"></i>
              </div>
              <div class="select-wrapper" style="margin-top: 10px">
                <span class="bold" style="margin-right: 10px"
                  >{{ $t('defects') }}:</span
                >
                <select
                  ref="defectSelect"
                  @change="onDefectSelect"
                  v-model="defect"
                  multiple
                  class="multi-select"
                  :disabled="!memory"
                >
                  <!-- <option disabled selected value="null">{{
                    $t('chooseDefect')
                  }}</option> -->
                  <option v-for="(v, i) in defects" :value="i" :key="`def${i}`">
                    {{ v }}
                  </option>
                </select>
                <!-- <i class="fa fa-arrow-down"></i> -->
              </div>
              <div
                v-if="$mq.desktop"
                class="alert alert-info multi-select-alert"
                role="alert"
              >
                *{{ $t('tradeIn.calc.multiTip') }}
              </div>
            </div>
            <div style="margin-top: 10px">
              <span class="bold" style="margin-right: 10px"
                >{{ $t('evaluation') }}:</span
              >
              {{ calculationValue }}$
            </div>
            <div style="margin-top: 10px">
              <span class="bold" style="margin-right: 10px"
                >{{ $t('evaluation_ideal') }}:</span
              >
              {{ idealValue }}$
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div id="tradein-bg" class="bg-pos"></div>
        </div>
      </div>
    </div>
    <div class="row mt-1">
      <div class="container">
        <div class="col-md-12">
          <div class="trade-in">
            <div class="h3 bold">{{ $t('tradeIn.benefits.header') }}</div>
            <ul style="padding-left: 20px">
              <li style="list-style-type: circle; color: #000">
                {{ $t('tradeIn.benefits.list.1') }}
              </li>
              <li style="list-style-type: circle; color: #000">
                {{ $t('tradeIn.benefits.list.2') }}
              </li>
              <li style="color: #000; list-style-type: circle">
                {{ $t('tradeIn.benefits.list.3') }}
              </li>
              <li style="list-style-type: circle; color: #000">
                {{ $t('tradeIn.benefits.list.4') }}
              </li>
            </ul>
            <div class="h3 bold">
              {{ $t('tradeIn.actions.header') }}
            </div>
            <p>1. {{ $t('tradeIn.actions.list.1') }}</p>
            <ul>
              <li>
                {{ $t('tradeIn.actions.list.11') }}
              </li>
            </ul>
            <p>2. {{ $t('tradeIn.actions.list.2') }}</p>
            <p>3. {{ $t('tradeIn.actions.list.3') }}</p>
            <p>4. {{ $t('tradeIn.actions.list.4') }}</p>
            <div class="h3 bold">{{ $t('tradeIn.conclusion.header') }}:</div>
            <p>
              {{ $t('tradeIn.conclusion.paragraph') }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading">...</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Tradein',
  data() {
    return {
      loading: true,
      model: null,
      memory: null,
      defect: [],
    }
  },
  computed: {
    models() {
      return this.tradeIn ? this.tradeIn.models : []
    },
    modelVariants() {
      if (this.model) {
        const model = this.tradeIn.models.find(
          (model) => model.name === this.model
        )
        return Object.keys(model.prices)
      }
      return []
    },
    defects() {
      if (!this.tradeIn || (this.tradeIn && !this.tradeIn.defects)) {
        return []
      }
      return this.tradeIn.defects.map(
        (defect) => defect[`name_${this.$i18n.locale}`]
      )
    },
    calculationValue() {
      if (this.model !== null && this.memory !== null && this.defect.length) {
        const m = this.tradeIn.models.find((model) => model.name === this.model)
        const defectValue = this.defect.reduce((sum, item) => {
          return sum + this.tradeIn.defects[item].reduction[this.model]
        }, 0)
        if (m) {
          let r = m.prices[this.memory] - defectValue
          if (r < 0) r = 0
          return r
        }
      }
      return 0
    },
    idealValue() {
      if (this.model !== null && this.memory !== null) {
        const m = this.tradeIn.models.find((model) => model.name === this.model)
        if (m) {
          return m.prices[this.memory]
        }
      }
      return 0
    },
    ...mapState(['tradeIn']),
  },
  methods: {
    onDeviceSelect() {
      this.memory = null
      this.defect = []
    },
    onMemorySelect() {
      this.defect = []
    },
    onDefectSelect() {},
  },
  beforeMount() {
    this.$store
      .dispatch('fetchTradein')
      .then(() => {
        this.loading = false
      })
      .catch((err) => {
        console.log('*[TRADEIN FETCH ERROR]', err)
      })
  },
}
</script>

<style>
.bold {
  font-weight: bold;
}
.mt-1 {
  margin-top: 50px;
}
.mb-1 {
  margin-bottom: 50px;
}
.select-wrapper {
  position: relative;
}
select {
  border-color: rgba(255, 67, 0, 0.9);
  border-radius: 8px;
  width: 100%;
  position: relative;
}
select:disabled {
  border-color: #ccc;
  cursor: auto;
}
select + i {
  position: absolute;
  right: 30px;
  top: 38px;
}
.multi-select {
  padding: 0;
}
select.multi-select option {
  border: none;
  border-bottom: 1px solid #ccc;
  padding-left: 10px;
  padding-right: 10px;
}
.multi-select-alert {
  margin-top: 10px;
}
/* .first {
  top: 57px !important;
} */
/* .top {
  padding-top: 72px;
} */
/* .calculator {
  max-width: 500px;
  margin: auto;
  padding-bottom: 20px;
} */
</style>
